"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSyncProjectRequestBody = isSyncProjectRequestBody;
const index_1 = require("../../actions/index");
function isSyncProjectRequestBody(p) {
  return (0, index_1.isProjectActionArray)(p);
}